module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('e-charts', {
    attrs: {
      "options": _vm.chartOptions,
      "auto-resize": ""
    }
  }), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-title"
  }, [_c('span', [_vm._v("DAILY LP GAIN / LOSS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-range"
  }, [_c('div', [_vm._v("7 played days ago")]), _vm._v(" "), _c('div', [_vm._v("today")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03b769fd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GainLossGraph.vue
// module id = 392
// module chunks = 1